import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Grid, Typography} from '@material-ui/core';
import {FieldArray, useFormikContext} from 'formik'
import {makeStyles} from "@material-ui/core/styles";
import Divider from '@material-ui/core/Divider';
import Loading from "../../../../../Loading";
import PopOverDetails from "../../../../../PopOverInfo";
import CotizarContext from "../../../../../../context/CotizarContext";

const useStyles = makeStyles((theme) => ({
    coberturasTable: {
        padding: theme.spacing(1),
    },
    tableHeader: {
        marginTop: "8px",
        fontFamily: 'Montserrat',
        fontSize: 20
    },
    tableRowLabel: {
        fontFamily: 'Nunito'
    },
    tableRowDetailLabel: {
        fontFamily: 'Nunito',
        color: "#969292",
        fontSize: "14px"
    },
    note: {
        fontFamily: 'Nunito',
        fontSize: 12,
        textAlign: "center",
        color: theme.palette.grey.A200
    },
    dataText: {
        fontFamily: 'Nunito',
        fontSize: 20
    },
    boxPrice: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "800px",
        height: "120px",
        margin: "0px 0px 8px -30px",
        backgroundColor: "#BB0D66"
    },
    priceTitle: {
        fontFamily: 'EncodeSansRegular',
        fontSize: 18,
        color: "#fff"
    },
    priceText: {
        fontFamily: 'EncodeSansBold',
        fontSize: 32,
        color: "#fff"
    },

}));

export default function CoberturasForm(props) {
    const classes = useStyles();
    const {cuotaMensual} = props;
    const {values} = useFormikContext();
    const [dictCoberturas, setDictCoberturas] = useState(null);
    const {coberturasInfo, coveragesToFilter} = useContext(CotizarContext);

    const viviendasDict = {
        '1021': 'Casa de ocupación permanente',
        '1022': 'Departamento de ocupación permanente',
        '1023': 'Vivienda en barrio cerrado',
        '1024': 'Vivienda/Departamento de ocupación transitoria',
    };
    const deduciblesDict = {
        1: 'Deducible Alt. 1',
        2: 'Deducible Alt. 2',
        3: 'Deducible Alt. 3',
    };

    function currencyFormat(num) {
        return '$ ' + num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    }

    useEffect(() => {
        let dict = {};
        coberturasInfo.map((item) =>
            dict[item.NumeroCobertura] = {
                descripcion: item.Descripcion,
                descripcionCompleta: item.DescripcionCompleta,
                obligatorio: item.Obligatorio
            });
        setDictCoberturas(dict)
    }, []);

    if (!dictCoberturas) return <Loading/>;
    return (
        <React.Fragment>
            <Grid container direction='column'>
                <Grid item container spacing={3} direction='column' className={classes.coberturasTable}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        margin: "24px 40px 16px 16px",
                    }}>
                        <Typography className={classes.tableHeader}>Cobertura</Typography>
                        <Typography className={classes.tableHeader}>Suma Asegurada</Typography>
                    </div>
                    <FieldArray name='coberturas'>{() => (
                        values.coberturas
                            .filter(cob => !coveragesToFilter.includes(cob['numeroCobertura']))
                            .map((item) => (
                                <Fragment>
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: "4px 0px 4px 24px",
                                    }}>
                                        <div style={{width: "65%"}}>
                                            <Typography className={classes.tableRowLabel}>
                                                {dictCoberturas[item.numeroCobertura].descripcion}
                                            </Typography>
                                        </div>
                                        <div style={{
                                            width: "20%", display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "right",
                                        }}>
                                            <Typography
                                                className={classes.tableRowLabel}>{currencyFormat(item.sumaAsegurada)}</Typography>
                                        </div>
                                        <div style={{width: "15%"}}>
                                            <PopOverDetails
                                                descripcion={dictCoberturas[item.numeroCobertura].descripcionCompleta}/>
                                        </div>
                                    </div>
                                    {item.numeroCobertura === '49'
                                        &&
                                        values.detalleMonopatines.map(itemDetail => (
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                margin: "-16px 0px 0px 40px",
                                            }}>
                                                <div style={{width: "65%"}}>
                                                    <Typography className={classes.tableRowDetailLabel}>
                                                        {itemDetail.descripcionMonopatines}
                                                    </Typography>
                                                </div>
                                                <div style={{
                                                    width: "20%", display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "right",
                                                }}>
                                                    <Typography
                                                        className={classes.tableRowDetailLabel}>{currencyFormat(parseInt(itemDetail.sumaAseguradaMonopatines))}</Typography>
                                                </div>
                                                <div style={{width: "15%"}}/>
                                            </div>
                                        ))}
                                    {item.numeroCobertura === '48'
                                    &&
                                    values.detalleBicicletas.map(itemDetail => (
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            margin: "-16px 0px 0px 40px",
                                        }}>
                                            <div style={{width: "65%"}}>
                                                <Typography className={classes.tableRowDetailLabel}>
                                                    {itemDetail.descripcionBicicletas}
                                                </Typography>
                                            </div>
                                            <div style={{
                                                width: "20%", display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "right",
                                            }}>
                                                <Typography
                                                    className={classes.tableRowDetailLabel}>{currencyFormat(parseInt(itemDetail.sumaAseguradaBicicletas))}</Typography>
                                            </div>
                                            <div style={{width: "15%"}}/>
                                        </div>
                                    ))}
                                    {item.numeroCobertura === '26'
                                        &&
                                        values.detalleEquipoElectronico.map(itemDetail => (
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                margin: "-16px 0px 0px 40px",
                                            }}>
                                                <div style={{width: "65%"}}>
                                                    <Typography className={classes.tableRowDetailLabel}>
                                                        {itemDetail.descripcionElectronico}
                                                    </Typography>
                                                </div>
                                                <div style={{
                                                    width: "20%", display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "right",
                                                }}>
                                                    <Typography
                                                        className={classes.tableRowDetailLabel}>{currencyFormat(parseInt(itemDetail.sumaAseguradaElectronico))}</Typography>
                                                </div>
                                                <div style={{width: "15%"}}/>
                                            </div>
                                        ))}
                                    <Divider light/>
                                </Fragment>
                            )
                        )
                    )}</FieldArray>

                    <Grid item container spacing={2} direction="column">
                        <Grid item container direction="row" spacing={1} justify='center' alignItems='baseline'>
                            <Grid item>
                                <Typography className={classes.tableHeader}>Tipo de vivienda:</Typography>
                            </Grid>
                            <Grid item>
                                <Typography
                                    className={classes.dataText}>{viviendasDict[values.tipoVivienda]}</Typography>
                            </Grid>
                        </Grid>
                        {values.deducible !== 0 && (
                            <Grid item container direction="row" spacing={1} justify='center' alignItems='baseline'>
                                <Grid item>
                                    <Typography className={classes.tableHeader}>Deducible:</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography
                                        className={classes.dataText}>{deduciblesDict[values.deducible]}</Typography>
                                </Grid>
                            </Grid>
                        )
                        }

                    </Grid>
                    <Grid item>
                        <Typography className={classes.note}>
                            Nota: si deseas modificar las coberturas seleccionadas debes realizar una nueva cotización
                            con las coberturas deseadas.
                        </Typography>
                    </Grid>
                    <Grid item/>
                </Grid>
                <div className={classes.boxPrice}>
                    <Typography className={classes.priceTitle}>Cuota mensual:</Typography>
                    <Typography className={classes.priceText}>$ {cuotaMensual}</Typography>
                </div>

            </Grid>
        </React.Fragment>
    );
}
